import { Immutable } from "immer";
import React from "react";

import type { UtilityLeftSideBarList as Value } from "@reactivated";

import { getLinkUrl } from "../../utils/wagtail";

type IProps = Immutable<{
    value: Value;
}>;

/**
 * sealy's left side-nav-bar list, rendered natively in-tree by PageSkeleton for
 * the full-document UtilityPage.
 *
 * Each link's url resolves through ``getLinkUrl`` (mirrors ``LinkValue.get_url``:
 * chosen page wins, else ``external_url``, else "").
 */
export const UtilityLeftSideBarList = (props: IProps): React.JSX.Element => {
    return (
        <nav className="list-group">
            <h2 className="list-group__header">{props.value.title ?? ""}</h2>
            <ul className="list-group__links">
                {(props.value.links ?? []).map((link, index) => (
                    <li className="list-group__item" key={index}>
                        <a
                            href={getLinkUrl(link)}
                            {...(link.open_in_new_tab
                                ? { target: "_blank" }
                                : {})}
                            title={link.html_title ?? ""}
                        >
                            {link.display_name ?? ""}
                        </a>
                    </li>
                ))}
            </ul>
        </nav>
    );
};
